import styled from "styled-components";
import { Modal } from "antd";

const StyledModal = styled(Modal)`
  &.ant-modal {
    .ant-modal-content {
      padding: 32px;
    }

    .ant-modal-header {
      margin-bottom: 32px;
    }

    .ant-modal-title {
      font-size: 18px;
      font-weight: 700;
    }

    .ant-form-item {
      width: 100%;
    }

    .ant-input-number {
      width: 100%;
    }

    .ant-form-vertical
      .ant-form-item:not(.ant-form-item-horizontal)
      .ant-form-item-label {
      padding-bottom: 2px;
    }

    .ant-modal-footer {
      margin-top: 32px;
    }
  }
`;

export default StyledModal;
